import {h} from 'hyperapp'

export default (props) =>
    props.gender === 'Male' ?
        <div class="identity-avatar col-md-6 col-sm-6 col-xs-6">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 425.2 425.2" class="svg-content" preserveAspectRatio="xMinYMin meet">
                <defs>
                    <filter id="f3" x="0" y="0" width="150%" height="150%">
                        <feOffset result="offOut" in="SourceAlpha" dx="0" dy="0" />
                        <feColorMatrix result="matrixOut" in="offOut" type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                        <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="5" />
                        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
                    </filter>
                </defs>
                <g filter="url(#f3)">
                    <g id="peau">
                        <g id="cou">
                            <path class="st0"
                                d="M162.2,176.6c0,14.3-0.1,28.6-0.1,42.9c6.4,21.7,25.7,37,47.9,38.2c23.5,1.3,45.3-13.6,53-36.4c0-14.9,
                            0.1-29.8,0.1-44.7c-12.9-3.6-31.2-7.3-53.2-7C190.4,169.9,174.1,173.2,162.2,176.6z"
                            ></path>
                            <path class="st1"
                                d="M183.4,202.5c4.4,4.6,9.6,9.2,15.6,13.7c23.4,17.4,47.8,23.4,64,25.7c0.1-23.4,0.2-46.9,0.3-70.3C236.6,
                            181.9,210,192.2,183.4,202.5z"
                            ></path>
                        </g>
                        <g id="oreilles">
                            <path class="st0"
                                d="M149.3,103.7c-0.7-0.7-7.5-7.2-15.7-5.3c-0.5,0.1-5.3,1.3-8.3,5.5c-7.4,10.6,1.2,33.8,15.1,37.9c3.1,0.9,
                            6.8,0.4,9.1-0.3C149.5,128.9,149.4,116.3,149.3,103.7z"
                            ></path>
                            <path class="st0"
                                d="M275.5,103.7c0.7-0.7,7.5-7.2,15.7-5.3c0.5,0.1,5.3,1.3,8.3,5.5c7.4,10.6-1.2,33.8-15.1,37.9
                            c-3.1,0.9-6.8,0.4-9.1-0.3C275.4,128.9,275.5,116.3,275.5,103.7z"
                            ></path>
                        </g>
                        <path id="visage" class="st2"
                            d="M145.1,33.2c1.4,40.8,1.8,81.7,3.8,122.5c0.4,8.3,3.8,16.1,9.6,22.1
                        c12.7,13.2,25.3,25.7,38.9,37.3c2.8,2.4,6.3,3.8,10,3.9c3.9,0.2,8.1,0.1,11.9-0.1c3.6-0.3,7.1-0.7,9.9-3
                        c14.8-12.4,23.8-23.4,36.2-36.2c6.8-7,10.7-16.2,11-26l3.8-120.4H145.1z"
                        ></path>
                        <g id="nez">
                            <path
                                class="st0"
                                d="M212.8,163.6c-1.7,0-3.4,0-5.1,0c-2.6-3-5.1-6-7.7-9.1C204.3,157.6,208.5,160.6,212.8,163.6z"
                            ></path>
                            <path
                                class="st0"
                                d="M212.8,163.6c1.7,0,3.4,0,5.1,0c2.6-3,5.1-6,7.7-9.1c-2.1-13.2-4.1-26.4-6.2-39.5c-2.3,0-4.6,0-6.9,0
                            C212.6,131.3,212.7,147.4,212.8,163.6z"
                            ></path>
                        </g>
                        <g id="bouche">
                            <path
                                class="st3"
                                d="M188.9,175.1c5,2.5,13,5.9,23.5,7.1c10.2,1.2,18.6-0.1,24-1.4c-6.2,0.7-14.4,1.1-23.8,0
                            C202.9,179.7,194.8,177.3,188.9,175.1z"
                            ></path>
                        </g>
                    </g>
                    <g id="yeux">
                        <circle fill={props.eye} cx="182.6" cy="115.9" r="9.2"></circle>
                        <circle fill={props.eye} cx="242.6" cy="115.9" r="9.2"></circle>
                    </g>
                    <g id="cheveux">
                        <path id="cheveux_1_" fill={props.hair}
                            d="M157.3,50.6c0.9,6.6,1.7,13.3,2.6,19.9c-4.1,3.3-8.2,6.7-12.3,10c0,13.4,0,26.7-0.1,40.1
                        c-4.1-28.8-8.1-57.6-12.2-86.4c2.2,0.5,4.4,1,6.6,1.5c-1.9-3.4-3.9-6.8-5.8-10.2c8.9-3.2,21.8-7.7,37.8-12.3
                        c18.5-5.3,27.9-7.9,37.8-8c18.1-0.2,32.3,5.3,42.4,9.2c11.6,4.5,20.6,9.7,26.9,13.8c-1.2,29.8-2.4,59.7-3.6,89.5
                        c-0.4-12.5-0.7-25-1.1-37.5c-3.6-3.7-7.2-7.3-10.8-11c1.2-7.5,2.5-15.1,3.7-22.6c-13.9,3.7-31.4,7.1-51.9,8.2
                        C193.4,56.1,172.9,53.6,157.3,50.6z"
                        ></path>
                        <g id="sourcils">
                            <path class="st5"
                                d="M168.2,104.4c8.5,2.5,17.1,5,25.6,7.6c1.3,0.4,2.6,0,3.5-1c1.2-1.3,1.7-2.4,1.2-2.8c-0.4-0.4-1.4-0.2-2.3,0.1
                            c-1.4,0.4-2.8,0.4-4.2,0c-7.6-2.2-15.3-4.4-22.9-6.5c-1.9-0.4-3.3-0.1-3.5,0.5C165.3,102.7,166.4,103.8,168.2,104.4z"
                            ></path>
                            <path class="st5"
                                d="M257.5,104.4c-8.5,2.5-17.1,5-25.6,7.6c-1.3,0.4-2.6,0-3.5-1c-1.2-1.3-1.7-2.4-1.2-2.8
                            c0.4-0.4,1.4-0.2,2.3,0.1c1.4,0.4,2.8,0.4,4.2,0c7.6-2.2,15.3-4.4,22.9-6.5c1.9-0.4,3.3-0.1,3.5,0.5
                            C260.3,102.7,259.3,103.8,257.5,104.4z"
                            ></path>
                        </g>
                    </g>
                    <g id="vetements">
                        <g id="habit">
                            <path class="st6"
                                d="M212.6,253.7c-4.9-7.5-9.8-15-14.7-22.5c-2.4-3.7-5.7-6.7-9.6-8.8c-9.3-5-23.5-11.3-34.1-16.7
                            c0,3.6,0,7.2,0.1,10.8c-28.6,6.9-57.1,13.8-85.7,20.7c-0.1,18.1-0.1,36.2-0.2,54.2c48.1,42.8,96.1,85.6,144.2,128.5
                            C212.6,364.5,212.6,309.1,212.6,253.7z"
                            ></path>
                            <path class="st4"
                                d="M212.6,253.7c4.9-7.5,9.8-15,14.7-22.5c2.4-3.7,5.7-6.7,9.6-8.8c9.3-5,23.5-11.3,34.1-16.7
                            c0,3.6,0,7.2-0.1,10.8c28.6,6.9,57.1,13.8,85.7,20.7c0.1,18.1,0.1,36.2,0.2,54.2c-48.1,42.8-96.1,85.6-144.2,128.5
                            C212.6,364.5,212.6,309.1,212.6,253.7z"
                            ></path>
                        </g>
                        <path id="masque" class="st4"
                            d="M277.4,117.8c0-2.9-0.1-4.7-0.4-13.7c0-1.6-0.1-2.8-0.1-3.7c-3.6-1.8-9-4.1-15.8-5.2
                        c-3.6-0.6-10.8-1.5-19.6,0.2c-6.4,1.2-13.3,3.6-16.7,4.9c-5.4,2-7.5,3.1-11.2,3c-4.2-0.1-6.6-1.6-11.1-3.5c0,0-8-3.4-17.5-5.2
                        c-4.4-0.8-14.5-2.6-25.9,0.8c-5.2,1.6-9.1,3.8-11.6,5.3c0,6.2,0,10.8,0,14c0,0.7,0,1.8,0,3.3c0,1.3,0,2.3,0,2.7
                        c0,3,0.2,6.6,0.3,8.1c2.5,2.1,6.3,4.9,11.5,7.1c9.2,3.9,17.2,3.6,22.1,3.5c4-0.2,10.1-0.4,17.2-3.3c6.9-2.8,11.5-6.6,14.1-9.2
                        c2.8,2.7,7.5,6.5,14.3,9.2c9.3,3.6,17.4,3.2,21.3,3c1.7-0.1,8.7-0.6,17.2-3.9c4.9-1.9,8.7-4.1,11.5-6
                        C277.4,124.4,277.5,120.5,277.4,117.8z M202.8,117.8c-0.9,6.5-11.8,10.6-24.3,9c-12.5-1.5-21.8-8.1-20.9-14.6
                        c0.9-6.5,11.8-10.6,24.3-9C194.4,104.7,203.7,111.3,202.8,117.8z M247.3,126.8c-12.5,1.5-23.4-2.5-24.3-9
                        c-0.9-6.5,8.4-13.1,20.9-14.6c12.5-1.5,23.4,2.5,24.3,9C269.1,118.7,259.8,125.3,247.3,126.8z"
                        ></path>
                    </g>
                </g>
            </svg>
        </div>
        :
        <div class="identity-avatar col-md-6 col-sm-6 col-xs-6">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 425.2 425.2" class="svg-content" preserveAspectRatio="xMinYMin meet">
                <defs>
                    <filter id="f3" x="0" y="0" width="150%" height="150%">
                        <feOffset result="offOut" in="SourceAlpha" dx="0" dy="0" />
                        <feColorMatrix result="matrixOut" in="offOut" type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                        <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="5" />
                        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
                    </filter>
                </defs>
                <g filter="url(#f3)">
                    <g id="peau">
                        <g id="cou">
                            <path id="cou_1_" class="st0"
                                d="M178.6,203.4c0,13.6-0.1,27.2-0.1,40.8c22.2,0,44.5,0,66.7,0.1c0-13.6-0.1-27.2-0.1-40.8
                            C223,203.4,200.8,203.4,178.6,203.4z"
                            ></path>
                            <path id="ombre_2_" class="st1"
                                d="M168,202.3c5.1,6.2,12.1,13.4,21.5,20.1c21.8,15.5,44,19.5,56.2,20.6
                            c-0.2-14.9-0.4-29.8-0.6-44.8C219.4,199.6,193.7,200.9,168,202.3z"
                            ></path>
                        </g>
                        <g id="oreilles_2_">
                            <path class="st0"
                                d="M149.1,127.9c-0.7-0.7-7.6-7.3-15.9-5.3c-0.5,0.1-5.4,1.3-8.4,5.6c-7.5,10.7,1.2,34.2,15.2,38.3
                            c3.2,0.9,6.8,0.4,9.2-0.3C149.2,153.4,149.1,140.6,149.1,127.9z"
                            ></path>
                            <path class="st0"
                                d="M275.4,127.8c0.7-0.7,7.6-7.3,15.9-5.3c0.5,0.1,5.4,1.3,8.4,5.6c7.5,10.7-1.2,34.2-15.2,38.3
                            c-3.2,0.9-6.8,0.4-9.2-0.3C275.3,153.4,275.3,140.6,275.4,127.8z"
                            ></path>
                        </g>
                        <path id="visage_1_" class="st2"
                            d="M139,98.2c1.8,16.1,3.6,32.1,5.4,48.2c4,35.6,25.3,67.1,57.1,83.5c0.4,0.2,0.9,0.4,1.3,0.7
                        c2.2,0.6,5.4,1.3,9.3,1.3c3.6,0,6.6-0.7,8.8-1.3c0.3-0.1,0.7-0.4,1.2-0.6c31.9-16.4,53.3-47.9,57.3-83.6c1.8-16,3.6-32,5.3-48
                        c-24.2-17.2-48.4-34.4-72.6-51.6C187.8,63.9,163.4,81,139,98.2z"
                        ></path>
                        <g id="nez_2_">
                            <path class="st0"
                                d="M212,181.1c-1.7,0-3.4,0-5.2,0c-2.4-4.1-4.7-8.2-7.1-12.3C203.8,172.9,207.9,177,212,181.1z"
                            ></path>
                            <path class="st0"
                                d="M212,181.1c1.7,0,3.4,0,5.2,0c2.3-2.9,4.7-5.9,7-8.8c-2.4-12.6-4.8-25.2-7.2-37.8c-1.7,0-3.4,0-5.2,0
                            C211.8,150.1,211.9,165.6,212,181.1z"
                            ></path>
                        </g>
                        <g id="bouche_2_">
                            <path class="st3"
                                d="M188.4,191.5c5,2.6,13.2,5.9,23.8,7.2c10.3,1.2,18.8-0.1,24.3-1.4c-6.3,0.7-14.5,1.1-24,0
                            C202.6,196.2,194.5,193.8,188.4,191.5z"
                            ></path>
                        </g>
                    </g>
                    <g id="yeux">
                        <circle fill={props.eye} cx="181.9" cy="135.1" r="9.2"></circle>
                        <circle fill={props.eye} cx="242.6" cy="135.1" r="9.2"></circle>
                    </g>
                    <g id="cheveux">
                        <path id="cheveux_1_" fill={props.hair}
                            d="M147.6,261.2c-11-35.2-22.1-75.5-33.1-110.7c-5.2-16.7-5-34.7,0.7-51.2
                        c5.1-14.8,10.2-29.5,15.3-44.3c6.5-18.9,21.8-33.5,40.9-39.1c3.8-1.1,7.7-2.3,11.5-3.4c18.5-5.5,38.1-5.8,56.7-0.9l13.6,3.6
                        c21.3,5.6,38,22,43.9,43.2l12.1,43.2c4.2,15.2,4,31.3-0.6,46.3c-11.2,36.2-22.4,77.4-33.7,113.6c-11.4,0-22.7,0-34.1-0.1
                        c1.5-14.2,2.9-33.4,4.4-47.6c5.6-5.2,12.7-12.9,19.1-23.4c5.5-9.1,8.9-17.6,10.9-24.3c0.8,0.2,1.9,0.5,3.2,0.6
                        c1,0.1,2.7,0.3,4.8-0.2c0.4-0.1,1.7-0.3,3.3-1c0.3-0.1,1.5-0.7,3-1.7c2.2-1.5,3.6-3.1,4.5-4.2c1.5-1.7,2.5-3.2,3.1-4.1
                        c1.8-2.9,2.7-5.3,3.3-7c0.5-1.4,1.1-3,1.5-5.3c0.6-3.5,0.4-6.2,0.4-6.8c-0.1-1.7-0.3-3.4-1.1-5.4c-1.1-2.8-2.8-4.5-3.3-5
                        c-0.6-0.5-2.1-2-4.7-3c-1.8-0.7-3.3-0.9-4.2-0.9c-0.5,0-2.6-0.2-5.2,0.6c-0.8,0.2-1.5,0.5-1.9,0.7c0.3-3.7,0.7-7.4,1.1-11.1
                        c0.4-3.8,0.9-7.4,1.3-11.1c-8.8-3.3-18.5-4.5-28.6-9.9c-18.2-9.7-32.6-20.5-43.7-30.2c-7.4,8.3-19.4,19.9-36.9,29.4
                        c-13.7,7.5-26.4,8.3-35.9,10.5c0.4,3.7,0.8,7.4,1.2,11.1c0.4,3.7,0.8,7.4,1.2,11c-0.3-0.1-0.8-0.3-1.3-0.4c0,0-1-0.3-1.8-0.4
                        c-2.7-0.5-5.6,0.2-5.6,0.2c-0.9,0.2-3.2,0.9-5.5,2.7c-0.5,0.4-3.2,2.6-4.6,6.7c-0.8,2.3-0.9,4.3-0.9,6.1c0,3,0.5,5.2,0.9,7
                        c0.8,3.4,1.9,6.1,3,8.1c0.6,1.2,1.6,3.1,3.3,5.2c3.9,4.8,9.3,8,12.9,8.4c2.1,0.2,4.4-0.1,4.4-0.1c0.8-0.1,1.5-0.2,2-0.4
                        c2.3,7.2,6.1,16.8,12.7,26.9c5.9,9,12.2,15.8,17.3,20.6c2.8,14.1,5.5,33.3,8.3,47.4C173.8,261.3,160.7,261.2,147.6,261.2z"
                        ></path>
                        <g id="sourcils">
                            <path class="st5"
                                d="M163.6,122.1c9.1,2.4,18.2,4.8,27.4,7.2c1.3,0.4,2.8,0.1,3.8-0.6c1.3-1,1.9-1.8,1.4-2.1
                            c-0.4-0.3-1.5-0.2-2.5-0.1c-1.5,0.2-3.1,0.1-4.5-0.2c-8.2-2.1-16.3-4.1-24.5-6.2c-2-0.4-3.6-0.2-3.8,0.2
                            C160.6,120.6,161.7,121.5,163.6,122.1z"
                            ></path>
                            <path class="st5"
                                d="M261.2,122.1c-9.1,2.4-18.2,4.8-27.4,7.2c-1.3,0.4-2.8,0.1-3.8-0.6c-1.3-1-1.9-1.8-1.4-2.1
                            c0.4-0.3,1.5-0.2,2.5-0.1c1.5,0.2,3.1,0.1,4.5-0.2c8.2-2.1,16.3-4.1,24.5-6.2c2-0.4,3.6-0.2,3.8,0.2
                            C264.2,120.6,263.1,121.5,261.2,122.1z"
                            ></path>
                        </g>
                    </g>
                    <g id="vetements_2_">
                        <g id="habit_2_">
                            <path class="st6"
                                d="M176.5,220.4c-0.1,2.3-0.3,4.7-0.4,7c-0.4,6.1-2.4,11.9-6.1,16.7c0,0-0.1,0.1-0.1,0.1c-3.1,4-6.5,6.7-8.9,8.3
                            c-2.9,1.4-7.3,3.3-12.9,5.2c-9.5,3.2-16.5,4.1-23.3,5.5c-7.1,1.4-17.1,3.7-29.3,7.2c0,15.3-0.1,30.5-0.1,45.8
                            c39.1,33.6,78.2,67.3,117.3,100.9c0-58.5,0-117.1,0-175.6c-5.5-1.3-11-2.6-16.5-3.9C189.7,231.8,183.1,226.1,176.5,220.4z"
                            ></path>
                            <path class="st4"
                                d="M248.7,220.4c0.1,2.3,0.3,4.7,0.4,7c0.4,6.1,2.4,11.9,6.1,16.7c0,0,0.1,0.1,0.1,0.1c3.1,4,6.5,6.7,8.9,8.3
                            c2.9,1.4,7.3,3.3,12.9,5.2c9.5,3.2,16.5,4.1,23.3,5.5c7.1,1.4,17.1,3.7,29.3,7.2c0,15.3,0.1,30.5,0.1,45.8
                            c-39.1,33.6-78.2,67.3-117.3,100.9c0-58.5,0-117.1,0-175.6c5.5-1.3,11-2.6,16.5-3.9C235.5,231.8,242.1,226.1,248.7,220.4z"
                            ></path>
                        </g>
                        <path id="masque_2_" class="st4"
                            d="M280.9,136.5c0.4-4,0.9-8,1.3-12c-3.4-3.4-9.8-8.6-19.1-11.3c-9.7-2.8-17.9-1.4-21.8-0.7
                        c-8.7,1.6-16.5,4.9-16.5,4.9c-5.9,2.5-7.9,4.3-12,4.1c-3.9-0.2-5.6-2-10.9-4.7c0,0-7-3.5-15.1-5.4c-13.4-3.2-25.2,1-28.4,2.2
                        c-7.5,2.9-13,7.2-16.6,10.7c0.4,3.6,0.8,7.3,1.2,10.9c0.3,2.4,0.5,4.8,0.8,7.2c5.7,6,11.6,9.1,15.1,10.7c9,3.9,16.9,3.9,22.3,3.8
                        c4.7-0.1,10.1-0.1,16.6-2.6c6.9-2.6,11.5-6.6,14.1-9.2c2.8,2.7,7.5,6.5,14.3,9.2c9.3,3.6,17.4,3.2,21.3,3c0,0,0.2,0,0.5,0
                        c9.1-0.7,15.9-3.4,18.9-4.7c5.4-2.4,9.7-5.2,13.1-8C280.2,142,280.6,139.2,280.9,136.5z M200.5,135.3c-0.4,6.8-10.2,11.6-21.8,10.8
                        c-11.6-0.8-20.7-7-20.3-13.8c0.4-6.8,10.2-11.6,21.8-10.8C191.9,122.3,201,128.5,200.5,135.3z M246.5,146.3
                        c-11.3,0.6-20.7-4.4-21-11.2c-0.3-6.8,8.7-12.8,20-13.4c11.3-0.6,20.7,4.4,21,11.2C266.8,139.6,257.8,145.7,246.5,146.3z"
                        ></path>
                    </g>
                </g>
            </svg>
        </div>
